"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.regexp.split");
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/createForOfIteratorHelper.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.seal");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _editorForVue = require("@wangeditor/editor-for-vue");
var _scrunchieArrangement = require("@/api/scrunchieArrangement/scrunchieArrangement");
var _ossUpload = require("@/utils/ossUpload");
var _vEmojiPicker = require("v-emoji-picker");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// , emojisDefault, categoriesDefault
var _default = exports.default = {
  components: {
    VEmojiPicker: _vEmojiPicker.VEmojiPicker,
    Editor: _editorForVue.Editor,
    Toolbar: _editorForVue.Toolbar
  },
  // emojisDefault, categoriesDefault
  data: function data() {
    return {
      vEmojiPickerShow: false,
      dialogVisible: false,
      conditionType: {},
      // 条件
      optionProps: {
        value: 'id',
        label: 'categoryName',
        children: 'children',
        checkStrictly: true
      },
      options: [],
      fileList: [],
      newFileList: [],
      // 新地址集合
      timeArray: [],
      // 时间
      ruleForm: {
        path: [],
        pathName: [],
        contentList: [],
        model: 1,
        enable: 1,
        text: '',
        // 文案
        onlineStartTime: '',
        // 上线开始时间
        onlineEndTime: '',
        // 上线结束时间
        id: ''
      },
      rules: {
        title: [{
          required: true,
          message: '请输入课程标题',
          trigger: 'blur'
        }, {
          min: 1,
          max: 500,
          message: '长度在 1 到 100 个字符',
          trigger: 'blur'
        }],
        sort: [{
          type: 'number',
          required: true,
          message: '请输入排序'
        }],
        viewed: [{
          type: 'number',
          required: true,
          message: '请输入观看次数'
        }]
      },
      editor: null,
      toolbarConfig: {
        excludeKeys: ['group-image', 'group-video']
      },
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            customUpload: function () {
              var _customUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(file, insertFn) {
                var pictureUrl, _t;
                return (0, _regenerator2.default)().w(function (_context) {
                  while (1) switch (_context.p = _context.n) {
                    case 0:
                      _context.p = 0;
                      _context.n = 1;
                      return (0, _ossUpload.uploadOSS)(file);
                    case 1:
                      pictureUrl = _context.v;
                      insertFn(pictureUrl);
                      _context.n = 3;
                      break;
                    case 2:
                      _context.p = 2;
                      _t = _context.v;
                      console.log('error ->', _t);
                    case 3:
                      return _context.a(2);
                  }
                }, _callee, null, [[0, 2]]);
              }));
              function customUpload(_x, _x2) {
                return _customUpload.apply(this, arguments);
              }
              return customUpload;
            }()
          }
        }
      },
      mode: 'default',
      // or 'simple'
      EditorOpen: false // 显示隐藏
    };
  },
  methods: {
    onCreated: function onCreated(editor) {
      this.editor = Object.seal(editor);
      // 一定要用 Object.seal() ，否则会报错
    },
    // 将v-emoji-picker中选择的表情添加到评论内容中
    selectEmoji: function selectEmoji(emoji) {
      this.ruleForm.text += emoji.data;
      console.log(emoji);
    },
    handleRemove: function handleRemove(file, fileLists) {
      var _this = this;
      // 删除已经上传过的
      this.fileList.forEach(function (item, index) {
        if (file.url === item.url) {
          _this.fileList.splice(index, 1);
        }
      });
    },
    handleChange: function handleChange(file, fileList) {
      this.fileList.push(file);
    },
    // 下拉框查询
    categoryListApi: function () {
      var _categoryListApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = {};
              _context2.n = 1;
              return (0, _scrunchieArrangement.categoryListApi)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.options = res.data;
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function categoryListApi() {
        return _categoryListApi2.apply(this, arguments);
      }
      return categoryListApi;
    }(),
    open: function open(data) {
      // this.editor = new wangEditor('editor-container')// 'editor-container'是你的编辑器容器的id
      // this.editor.create()
      this.conditionType = data;
      this.EditorOpen = true;
      this.categoryListApi();
      /*
      接收data对象：
      type：add、editor（添加，编辑）
      name：名称
      id：id
      */
      if (data.type === 'add') {
        // console.log('添加')
      } else {
        this.getByIdApi(data.id);
      }
      this.dialogVisible = true;
    },
    onClose: function onClose() {
      this.fileList = [];
      this.newFileList = [];
      this.timeArray = [];
      this.ruleForm = {
        path: [],
        contentList: [],
        model: 1,
        enable: 1,
        text: '',
        // 文案
        onlineStartTime: '',
        // 上线开始时间
        onlineEndTime: '',
        // 上线结束时间
        id: null
      };
      this.vEmojiPickerShow = false;
      this.$refs['ruleForm'].resetFields();
      this.dialogVisible = false;
    },
    onCascadeCharge: function onCascadeCharge(value) {
      this.ruleForm.pathName = this.getLabelsByValues(value, this.options);
    },
    onVEmojiPicker: function onVEmojiPicker() {
      this.vEmojiPickerShow = !this.vEmojiPickerShow;
    },
    getLabelsByValues: function getLabelsByValues(values, options) {
      var labels = [];
      function findLabels(values, options) {
        var _iterator = (0, _createForOfIteratorHelper2.default)(options),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var option = _step.value;
            if (values.includes(option.id)) {
              labels.push(option.categoryName);
            }
            if (option.children && option.children.length) {
              findLabels(values, option.children);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      findLabels(values, options);
      return labels;
    },
    submitForm: function () {
      var _submitForm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(formName) {
        var _this2 = this;
        var _iterator2, _step2, item, arr, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              // 遍历出未上传的
              // await this.fileList.forEach((item, index) => {
              //   if (item.status === 'ready') {
              //     this.handleFileUpload(item.raw)
              //   }
              // })
              _iterator2 = (0, _createForOfIteratorHelper2.default)(this.fileList);
              _context3.p = 1;
              _iterator2.s();
            case 2:
              if ((_step2 = _iterator2.n()).done) {
                _context3.n = 4;
                break;
              }
              item = _step2.value;
              if (!(item.status === 'ready')) {
                _context3.n = 3;
                break;
              }
              _context3.n = 3;
              return this.handleFileUpload(item.raw);
            case 3:
              _context3.n = 2;
              break;
            case 4:
              _context3.n = 6;
              break;
            case 5:
              _context3.p = 5;
              _t3 = _context3.v;
              _iterator2.e(_t3);
            case 6:
              _context3.p = 6;
              _iterator2.f();
              return _context3.f(6);
            case 7:
              arr = this.fileList.filter(function (item) {
                return item.status === 'success';
              }).map(function (item) {
                return item.url;
              }); // setTimeout(() => {
              this.ruleForm.contentList = arr.concat(this.newFileList);
              // console.log(this.ruleForm.contentList)
              this.$refs[formName].validate(function (valid) {
                if (valid) {
                  if (_this2.conditionType.type === 'add') {
                    _this2.saveMaterialManagerApi();
                  } else {
                    _this2.updateMaterialManagerApi();
                  }
                } else {
                  console.log('error submit!!');
                  return false;
                }
              });
              // }, 1000)
            case 8:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 5, 6, 7]]);
      }));
      function submitForm(_x3) {
        return _submitForm.apply(this, arguments);
      }
      return submitForm;
    }(),
    resetForm: function resetForm(formName) {
      this.fileList = [];
      this.newFileList = [];
      this.timeArray = [];
      this.ruleForm.path = [];
      this.ruleForm.contentList = [];
      this.ruleForm.model = 1;
      this.ruleForm.text = ''; // 文案
      this.ruleForm.onlineStartTime = ''; // 上线开始时间
      this.ruleForm.onlineEndTime = ''; // 上线结束时间
      this.$refs['ruleForm'].resetFields();
    },
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(file) {
        var pictureUrl, _t4;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return (0, _ossUpload.uploadOSS)(file);
            case 1:
              pictureUrl = _context4.v;
              this.newFileList.push(pictureUrl);
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              console.log('error ->', _t4);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function handleFileUpload(_x4) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    saveMaterialManagerApi: function () {
      var _saveMaterialManagerApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5() {
        var params, res, _t5;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              params.categoryId = params.path[params.path.length - 1];
              if (params.path) {
                params.path = params.path.join(',');
              }
              if (params.onlineStartTime) {
                params.onlineStartTime = this.timeArray[0];
                params.onlineEndTime = this.timeArray[1];
              }
              if (params.pathName) {
                params.pathName = params.pathName.join(',');
              }
              console.log('params----', params);
              _context5.n = 1;
              return (0, _scrunchieArrangement.saveMaterialManagerApi)(params);
            case 1:
              res = _context5.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '添加成功'
                });
                this.onClose();
                this.$emit('Refresh');
              }
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t5 = _context5.v;
              console.log(_t5);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function saveMaterialManagerApi() {
        return _saveMaterialManagerApi2.apply(this, arguments);
      }
      return saveMaterialManagerApi;
    }(),
    updateMaterialManagerApi: function () {
      var _updateMaterialManagerApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee6() {
        var params, res, _t6;
        return (0, _regenerator2.default)().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              params.categoryId = params.path[params.path.length - 1];
              params.path = params.path.join(',');
              if (this.timeArray[0]) {
                params.onlineStartTime = this.timeArray[0];
                params.onlineEndTime = this.timeArray[1];
              }
              params.pathName = params.pathName.join(',');
              _context6.n = 1;
              return (0, _scrunchieArrangement.updateMaterialManagerApi)(params);
            case 1:
              res = _context6.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '编辑成功'
                });
                this.onClose();
                this.$emit('Refresh');
              }
              _context6.n = 3;
              break;
            case 2:
              _context6.p = 2;
              _t6 = _context6.v;
              console.log(_t6);
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 2]]);
      }));
      function updateMaterialManagerApi() {
        return _updateMaterialManagerApi2.apply(this, arguments);
      }
      return updateMaterialManagerApi;
    }(),
    getByIdApi: function () {
      var _getByIdApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee7(id) {
        var params, res, dates, _t7;
        return (0, _regenerator2.default)().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _context7.p = 0;
              params = {
                id: id
              };
              _context7.n = 1;
              return (0, _scrunchieArrangement.getByIdApi)(params);
            case 1:
              res = _context7.v;
              if (res.code === 0) {
                dates = res.data;
                this.ruleForm.path = dates.path.split(',').map(Number);
                this.ruleForm.id = dates.id;
                // 图片回显
                if (dates.contentList) {
                  this.fileList = dates.contentList.map(function (item) {
                    return {
                      url: item
                    };
                  });
                }
                this.ruleForm.model = dates.model;
                this.ruleForm.text = dates.text;
                if (dates.onlineStartTime) {
                  this.timeArray = [dates.onlineStartTime, dates.onlineEndTime]; // 时间展示
                }
                this.ruleForm.onlineStartTime = dates.onlineStartTime;
                this.ruleForm.enable = dates.enable;
                this.ruleForm.onlineEndTime = dates.onlineEndTime;
                this.ruleForm.pathName = dates.pathName.split(',');
              }
              _context7.n = 3;
              break;
            case 2:
              _context7.p = 2;
              _t7 = _context7.v;
              console.log(_t7);
            case 3:
              return _context7.a(2);
          }
        }, _callee7, this, [[0, 2]]);
      }));
      function getByIdApi(_x5) {
        return _getByIdApi2.apply(this, arguments);
      }
      return getByIdApi;
    }()
  }
};